'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["FieldSelectItemComponent", "activeFieldNames", "className", "currencyCode", "editorSubtitle", "fieldGroups", "fields", "filterFamily", "getDefaultTimezone", "getDescriptionString", "getFamilyValueResolver", "getFilterFamilyName", "getFilterFamilyObjectName", "getInputComponent", "getIsUngated", "getLabelString", "getOperatorLabel", "getOperators", "getPlaceholder", "getReferencedObjectType", "getSpecialOptionsForReferenceType", "getObjectPropertyLabel", "isFieldDescriptionVisible", "isFiscalYearEnabled", "isRollingDateOffsetInputEnabled", "isXoEnabled", "labelOperatorEditSave", "loadMoreFields", "renderFieldLink", "searchable", "showIncludeUnknownValues", "style", "value", "filterBranch", "handleIncludeObjectsWithNoAssociatedObjectsChange", "nullIssueRelatedState", "updateNullIssueRelatedState", "isFilterIncompatible", "canFilterBeConverted"];
import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { ENUMERATION } from 'customer-data-filters/converters/listSegClassic/OperationTypes';
import { ESC } from 'UIComponents/constants/KeyCodes';
import { EmailLinkClicked } from 'customer-data-filters/filterQueryFormat/operator/Operators';
import { List } from 'immutable';
import { isValidOperator } from 'customer-data-filters/filterQueryFormat/operator/Operator';
import { mapOf, setOf } from 'react-immutable-proptypes';
import FilterEditorFieldSelect from './FilterEditorFieldSelect';
import FilterEditorPanel from './FilterEditorPanel';
import FilterFieldGroupType from 'customer-data-filters/components/propTypes/FilterFieldGroupType';
import FilterFieldType from 'customer-data-filters/components/propTypes/FilterFieldType';
import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
import FilterOperatorRefinableInput from '../operator/FilterOperatorRefinableInput';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FilterType from '../propTypes/FilterType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import NullRelatedState from '../propTypes/NullRelatedState';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import getIn from 'transmute/getIn';
import isRecord from 'transmute/isRecord';
import FilterUserAction from '../../filterQueryFormat/FilterUserAction';
import { CHANGE_CRITERIA_CLICKED } from '../../filterQueryFormat/UsageSubActionTypes';
import { __ANY_LINK } from '../../converters/listSegClassic/ListSegConstants';
import UpdateFilterWithExternalOptionsNotification from 'customer-data-filters/components/operator/UpdateFilterWithExternalOptionsNotification';
import { attemptToConvertExternalOptionsFilter } from 'customer-data-filters/utilities/externalOptionsConversionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FilterEditorOperatorEdit extends Component {
  constructor(props) {
    super(props);
    this.handleGoBack = () => {
      const {
        fieldSelected
      } = this.state;
      if (!fieldSelected) {
        this.setState({
          fieldSelected: true
        });
      } else {
        this.props.onDone(syntheticEvent(this.state.initialValue), true);
      }
    };
    this.handleEditField = () => {
      const {
        onUserAction,
        filterFamily
      } = this.props;
      if (typeof onUserAction === 'function') {
        onUserAction(FilterUserAction({
          filterFamily,
          subAction: CHANGE_CRITERIA_CLICKED
        }));
      }
      this.setState({
        error: FilterOperatorErrorRecord({
          error: false
        }),
        fieldSelected: false
      });
    };
    this.handleChange = (evt, options) => {
      const {
        target: {
          value
        }
      } = evt;
      if (isValidOperator(value)) {
        if (options && options.hasClickedUpdate) {
          this.props.onChange(syntheticEvent(value.set('hasTimezones', false), options));
        } else {
          this.props.onChange(syntheticEvent(value));
        }
      }
      this.setState({
        draft: options && options.hasClickedUpdate ? value.set('hasTimezones', false) : value,
        error: FilterOperatorErrorRecord({
          error: false
        })
      });
    };
    this.handleUpdateClick = () => {
      const {
        value,
        onChange
      } = this.props;
      if (!(value !== null && value !== void 0 && value.field)) {
        return;
      }
      const newValue = attemptToConvertExternalOptionsFilter(value);
      onChange(syntheticEvent(newValue));
      this.setState({
        draft: newValue,
        error: FilterOperatorErrorRecord({
          error: false
        })
      });
    };
    this.handleSelectField = ({
      target: {
        value: newValue
      }
    }) => {
      const {
        value
      } = this.props;
      const {
        draft
      } = this.state;
      this.setState({
        fieldSelected: true
      });
      const workingValue = draft || value;
      const newDraft = this.getIsValuePreservable(workingValue, newValue) ? workingValue.set('field', newValue.get('field')) : newValue;
      this.handleChange(syntheticEvent(newDraft));
    };
    this.handleKeyUp = evt => {
      if (evt.keyCode === ESC) {
        evt.stopPropagation();
        this.handleGoBack();
      }
    };
    this.handleSearchChange = evt => {
      const {
        target: {
          value = ''
        }
      } = evt;
      const {
        onFieldSearchChange,
        filterFamily
      } = this.props;
      this.setState({
        searchValue: value
      });
      onFieldSearchChange(value, filterFamily);
    };
    this.handleSubmit = evt => {
      evt.preventDefault();
      const {
        onDone,
        validateOperator,
        value
      } = this.props;
      const {
        draft
      } = this.state;
      const workingValue = draft || value;
      const validationError = validateOperator(workingValue);
      const error = isRecord(validationError) ? validationError : FilterOperatorErrorRecord(validationError);
      const isError = error.get('error') || false;
      if (isValidOperator(workingValue) && !isError) {
        onDone(syntheticEvent(workingValue));
        this.setState({
          error: FilterOperatorErrorRecord({
            opts: error.get('opts') || {}
          })
        });
      } else {
        this.setState({
          error
        });
      }
    };
    this.state = {
      draft: null,
      error: FilterOperatorErrorRecord({
        error: false
      }),
      fieldSelected: true,
      initialValue: props.value,
      searchValue: ''
    };
  }
  componentDidMount() {
    this.setState({
      initialValue: this.props.value
    });
  }
  getIsValuePreservable(oldValue, newValue) {
    const {
      getFamilyValueResolver,
      getOperators,
      filterFamily
    } = this.props;
    const oldValueType = getIn(['field', 'type'], oldValue);
    const newValueType = getIn(['field', 'type'], newValue);
    const validOperators = getOperators(newValue.field);

    // HACK: CTA's are special because they use a custom input that fetches
    // different options for each CTA. This means they can never be preserved.
    if (filterFamily === DSAssetFamilies.CTA) {
      return false;
    }

    // HACK: Similar to CTAs Email Links use a custom input that does a different
    // fetch per email selected so they can't be persisted (unless `Any link` is selected).
    if (oldValue.constructor === EmailLinkClicked) {
      if (oldValue.value === __ANY_LINK) {
        return true;
      } else {
        return false;
      }
    }
    if (!validOperators.includes(oldValue.constructor)) {
      return false;
    }
    if (!oldValue.value) {
      return true;
    }

    // Enumeration properties that are not fetched externally will have options
    // on the object to compare to.
    if (!getFamilyValueResolver(oldValue) && !getFamilyValueResolver(newValue) && oldValueType === ENUMERATION && newValueType === ENUMERATION) {
      const newOptions = getIn(['field', 'options'], newValue) || List();
      if (oldValue.constructor.isIterableField('value')) {
        return oldValue.value.every(value => newOptions.findIndex(option => option.value === value) !== -1);
      }
      return newOptions.findIndex(option => option.value === oldValue.value) !== -1;
    }
    return getFamilyValueResolver(oldValue) === getFamilyValueResolver(newValue);
  }
  render() {
    const _this$props = this.props,
      {
        FieldSelectItemComponent,
        activeFieldNames,
        className,
        currencyCode,
        editorSubtitle,
        fieldGroups,
        fields,
        filterFamily,
        getDefaultTimezone,
        getDescriptionString,
        getFamilyValueResolver,
        getFilterFamilyName,
        getFilterFamilyObjectName,
        getInputComponent,
        getIsUngated,
        getLabelString,
        getOperatorLabel,
        getOperators,
        getPlaceholder,
        getReferencedObjectType,
        getSpecialOptionsForReferenceType,
        getObjectPropertyLabel,
        isFieldDescriptionVisible,
        isFiscalYearEnabled,
        isRollingDateOffsetInputEnabled,
        isXoEnabled,
        labelOperatorEditSave = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterEditorOperatorEdit.save"
        }),
        loadMoreFields,
        renderFieldLink,
        searchable,
        showIncludeUnknownValues,
        style,
        value,
        filterBranch,
        handleIncludeObjectsWithNoAssociatedObjectsChange,
        nullIssueRelatedState,
        updateNullIssueRelatedState,
        isFilterIncompatible,
        canFilterBeConverted
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      draft,
      error,
      fieldSelected,
      initialValue,
      searchValue
    } = this.state;
    const workingValue = draft || value;
    const valueTitle = workingValue && workingValue.field && getLabelString(workingValue.field);
    const isValueDescriptionShown = isFieldDescriptionVisible && workingValue && workingValue.field;
    const valueDescription = isValueDescriptionShown ? getDescriptionString(workingValue.field) : null;
    const showEditField = !getIn(['field', 'metadata', 'hasNoFieldOptions'], workingValue) && fieldSelected;
    const valueUrl = workingValue && getIn(['field', 'url'], workingValue);
    const isNameBlocklisted = propertyRecord => !['favoriteUserList'].includes(propertyRecord.get('name'));
    const creatableFieldGroups = fieldGroups ? (filterFamily && fieldGroups.get(filterFamily) || fieldGroups).map(fieldGroup => fieldGroup.update('properties', list => list.filter(isNameBlocklisted))) : undefined;
    const dataAttributes = Object.keys(rest).filter(key => key.startsWith('data-')).reduce((acc, key) => {
      acc[key] = rest[key];
      return acc;
    }, {});
    return /*#__PURE__*/_jsx(FilterEditorPanel, Object.assign({
      "data-selenium-test": "XOFilterEditor-edit-panel"
    }, dataAttributes, {
      className: className,
      description: valueDescription,
      editorSubtitle: editorSubtitle,
      getIsUngated: getIsUngated,
      handleGoBack: this.handleGoBack,
      isBodyHeightFixed: !fieldSelected,
      isXoEnabled: isXoEnabled,
      onEditFieldClick: this.handleEditField,
      onSubmit: this.handleSubmit,
      renderFieldLink: renderFieldLink,
      saveLabel: labelOperatorEditSave,
      showEditField: showEditField,
      style: style,
      title: valueTitle,
      url: valueUrl,
      value: fieldSelected ? workingValue : undefined,
      children: fieldSelected ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [isFilterIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
          canFilterBeConverted: canFilterBeConverted,
          onUpdateClick: this.handleUpdateClick
        }), /*#__PURE__*/_jsx(FilterOperatorRefinableInput, {
          currencyCode: currencyCode,
          error: error,
          filterBranch: filterBranch,
          filterFamily: filterFamily,
          getDefaultTimezone: getDefaultTimezone,
          getFamilyValueResolver: getFamilyValueResolver,
          getFilterFamilyObjectName: getFilterFamilyObjectName,
          getInputComponent: getInputComponent,
          getIsUngated: getIsUngated,
          getObjectPropertyLabel: getObjectPropertyLabel,
          getOperatorLabel: getOperatorLabel,
          getOperators: getOperators,
          getPlaceholder: getPlaceholder,
          getReferencedObjectType: getReferencedObjectType,
          getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
          handleIncludeObjectsWithNoAssociatedObjectsChange: handleIncludeObjectsWithNoAssociatedObjectsChange,
          initialValue: initialValue,
          isFilterIncompatible: isFilterIncompatible,
          isFiscalYearEnabled: isFiscalYearEnabled,
          isRollingDateOffsetInputEnabled: isRollingDateOffsetInputEnabled,
          isXoEnabled: isXoEnabled,
          nullIssueRelatedState: nullIssueRelatedState,
          onChange: this.handleChange,
          showIncludeUnknownValues: showIncludeUnknownValues,
          updateNullIssueRelatedState: updateNullIssueRelatedState,
          value: workingValue
        })]
      }) : /*#__PURE__*/_jsx(FilterEditorFieldSelect, {
        FieldSelectItemComponent: FieldSelectItemComponent,
        activeFieldNames: activeFieldNames,
        fieldGroups: creatableFieldGroups,
        fields: fields,
        filterFamily: filterFamily,
        getFilterFamilyName: getFilterFamilyName,
        getIsUngated: getIsUngated,
        getLabelString: getLabelString,
        getOperators: getOperators,
        isXoEnabled: isXoEnabled,
        loadMoreFields: loadMoreFields,
        onChange: this.handleSelectField,
        onSearchChange: this.handleSearchChange,
        searchValue: searchValue,
        searchable: searchable,
        value: workingValue
      })
    }));
  }
}
FilterEditorOperatorEdit.propTypes = {
  FieldSelectItemComponent: PropTypes.func,
  activeFieldNames: setOf(PropTypes.string.isRequired).isRequired,
  canFilterBeConverted: PropTypes.bool.isRequired,
  className: PropTypes.string,
  currencyCode: PropTypes.string.isRequired,
  editorSubtitle: PropTypes.node,
  fieldGroups: mapOf(FilterFieldGroupType.isRequired),
  fields: mapOf(FilterFieldType),
  filterBranch: FilterType,
  filterFamily: PropTypes.string,
  getDefaultTimezone: PropTypes.func.isRequired,
  getDescriptionString: PropTypes.func.isRequired,
  getFamilyValueResolver: PropTypes.func.isRequired,
  getFilterFamilyName: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  getInputComponent: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  getLabelString: PropTypes.func.isRequired,
  getObjectPropertyLabel: PropTypes.func.isRequired,
  getOperatorLabel: PropTypes.func.isRequired,
  getOperators: PropTypes.func.isRequired,
  getPlaceholder: PropTypes.func.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  handleIncludeObjectsWithNoAssociatedObjectsChange: PropTypes.func,
  isFieldDescriptionVisible: PropTypes.bool.isRequired,
  isFilterIncompatible: PropTypes.bool.isRequired,
  isFiscalYearEnabled: PropTypes.bool.isRequired,
  isRollingDateOffsetInputEnabled: PropTypes.bool,
  isXoEnabled: PropTypes.bool,
  labelOperatorEditSave: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loadMoreFields: PropTypes.func,
  nullIssueRelatedState: NullRelatedState,
  onChange: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onFieldSearchChange: PropTypes.func.isRequired,
  onUserAction: PropTypes.func,
  renderFieldLink: PropTypes.func.isRequired,
  searchable: PropTypes.bool,
  showIncludeUnknownValues: PropTypes.bool.isRequired,
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  updateNullIssueRelatedState: PropTypes.func,
  validateOperator: PropTypes.func.isRequired,
  value: FilterOperatorType.isRequired
};